import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { iInterpreterRequestPayload, iInterpreterRequestState } from 'store/types/interpreter';

export const initialState: iInterpreterRequestState = {
    interpreterRequest: null
};

export const interpreterRequestSlice = createSlice({
  name: 'interpreterRequest',
  initialState,
  reducers: {
    setInterpreterRequest: (state, action: PayloadAction<iInterpreterRequestPayload>) => {
      // Replace the entire assembly state
        const interpreterRequest: iInterpreterRequestPayload = action.payload
        state.interpreterRequest = interpreterRequest
    },
    resetInterpreterRequest: (state) => {
        state.interpreterRequest = null
      }
  }
});

// The exported reducer
export default interpreterRequestSlice.reducer;
// Export the action
export const { setInterpreterRequest, resetInterpreterRequest } = interpreterRequestSlice.actions;
// Optional selector
export const interpreterRequestSelector = (state: RootState) =>
    state.interpreterRequest.interpreterRequest;